import { useCallback } from "react"
import { useAxiosInstances } from "../axios-instance/useAxiosInstances"
import { IRelatorioAcessRequest, IRelatorioQuantitativeRequest, IRelatorioSynteticRequest, IRelatorioReceitaRequest, IRelatorioConsumoAnalyticRequest } from "../../application/models/IRelatorioDash"

// infra/relatorios-dash/useRelatoriosDashApi.ts
export const useRelatoriosDashApi = () => {
    const { axiosAuthInstance } = useAxiosInstances()

    // 1. Acess (já existe)
    const getRelatorioAcessApi = useCallback(async (data: IRelatorioAcessRequest) => {
        const result = await axiosAuthInstance.post('/relatorios-dash/report-acess', data)
        return result.data
    }, [axiosAuthInstance])

    // 2. Quantitative (já existe)
    const getRelatorioQuantitativeApi = useCallback(async (data: IRelatorioQuantitativeRequest) => {
        const result = await axiosAuthInstance.post('/relatorios-dash/report-quantitative', data)
        return result.data
    }, [axiosAuthInstance])

    // 3. Syntetic (NOVO)
    const getRelatorioSynteticApi = useCallback(async (data: IRelatorioSynteticRequest) => {
        const result = await axiosAuthInstance.post('/relatorios-dash/report-syntetic', data)
        return result.data
    }, [axiosAuthInstance])

    // 4. Receita (NOVO)
    const getRelatorioReceitaApi = useCallback(async (data: IRelatorioReceitaRequest) => {
        const result = await axiosAuthInstance.post('/relatorios-dash/report-receita', data)
        return result.data
    }, [axiosAuthInstance])

    // 5. Consumo Analytic (NOVO)
    const getRelatorioConsumoAnalyticApi = useCallback(async (data: IRelatorioConsumoAnalyticRequest) => {
        const result = await axiosAuthInstance.post('/relatorios-dash/report-consumo-analytic', data)
        return result.data
    }, [axiosAuthInstance])

    // 6. Status da Fila (NOVO)
    const getRelatorioFilaStatusApi = useCallback(async (id: number) => {
        const result = await axiosAuthInstance.get(`/relatorios-dash/relatorio-status/${id}`)
        return result.data
    }, [axiosAuthInstance])

    const getMeusRelatoriosApi = useCallback(async (dias?: number) => {
        const params = dias ? `?dias=${dias}` : ''
        const result = await axiosAuthInstance.get(`/relatorios-dash/meus-relatorios${params}`)
        return result.data
    }, [axiosAuthInstance])

    const reprocessarRelatorioApi = useCallback(async (idRelatorioFila: number) => {
        const result = await axiosAuthInstance.post(`/relatorios-dash/reprocessar-relatorio/${idRelatorioFila}`)
        return result.data
    }, [axiosAuthInstance])

    const downloadRelatorioArquivoApi = useCallback(async (path: string) => {
        const sanitizedPath = path.startsWith('/') ? path : `/${path}`
        const result = await axiosAuthInstance.get(`/relatorios-dash${sanitizedPath}`, { responseType: 'blob' })
        return result.data
    }, [axiosAuthInstance])

    return {
        getRelatorioAcessApi,
        getRelatorioQuantitativeApi,
        getRelatorioSynteticApi,
        getRelatorioReceitaApi,
        getRelatorioConsumoAnalyticApi,
        getRelatorioFilaStatusApi,
        getMeusRelatoriosApi,
        reprocessarRelatorioApi,
        downloadRelatorioArquivoApi
    }
}